import request from '@/lib/request/';

const baseUri = 'auth/is-login';

/**
 * @returns {Promise}
 */
export function get() {
  return request({
    url: baseUri,
    method: 'get',
  });
}
